import React from 'react';
import { ScrollReveal } from './ui/ScrollReveal';
import { Flower2Icon, SproutIcon } from 'lucide-react';
export function RevelationSection() {
  return <section className="py-20 bg-sage relative overflow-hidden" data-id="element-189">
      {/* Background decorations */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-190">
        <SproutIcon className="absolute top-10 left-10 w-24 h-24 text-forest/5 transform -rotate-12" data-id="element-191" />
        <Flower2Icon className="absolute bottom-10 right-10 w-32 h-32 text-forest/5 transform rotate-12" data-id="element-192" />
      </div>

      <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-193">
        <ScrollReveal data-id="element-194">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-center text-forest mb-10" data-id="element-195">
            Tu Cocina es tu nueva Farmacia.
          </h2>
        </ScrollReveal>

        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 md:p-10 shadow-xl border border-forest/10" data-id="element-196">
          <ScrollReveal delay={100} data-id="element-197">
            <p className="font-sans text-lg text-brown/80 leading-relaxed mb-6" data-id="element-198">
              Existe un "Cajón Escondido" en nuestra botánica. Plantas como el{' '}
              <strong className="text-forest font-bold" data-id="element-199">Ambay</strong>, la{' '}
              <strong className="text-forest font-bold" data-id="element-200">Jarilla</strong> o la{' '}
              <strong className="text-forest font-bold" data-id="element-201">Carqueja</strong> tienen
              principios activos que la industria sintetiza para vendértelos 20
              veces más caros.
            </p>
          </ScrollReveal>

          <ScrollReveal delay={200} data-id="element-202">
            <div className="flex items-start gap-4 mt-8" data-id="element-203">
              <div className="bg-forest/10 p-3 rounded-full shrink-0" data-id="element-204">
                <Flower2Icon className="w-6 h-6 text-forest" data-id="element-205" />
              </div>
              <p className="font-sans text-lg text-brown/80 leading-relaxed" data-id="element-206">
                Este manual no es una recopilación de "yuyitos". Es{' '}
                <strong className="text-forest font-bold text-xl" data-id="element-207">
                  Un sistema simple que cualquier persona puede aplicar hoy
                  mismo
                </strong>
                . Te enseño a usar lo que hay en la dietética de tu barrio para
                crear remedios más potentes, seguros y naturales.
              </p>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>;
}